import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/shared/services/user.service';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'manage-publishers-component',
  templateUrl: './manage-publishers.component.html',
  styleUrls: ['./manage-publishers.component.scss'],
})
export class ManagePublishersComponent implements OnInit {
  public data: any;
  public columnsSettings: Array<any>;
  public startDate: Date;
  public endDate: Date;
  public isLoading: boolean;
  public isError: boolean;
  public currSubscription: any;
  public subscriptions: Array<any>;

  constructor(
    public router: Router,
    public sharedService: SharedService,
    public userService: UserService,
    public httpService: HttpService,
    public gridService: GridService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = [];
    this.columnsSettings = [
      { key: 'active', label: 'ACTIVE' },
      { key: 'publisher_name', label: 'NAME', filterType: 'INPUT' },
      {
        key: 'publisher_hb',
        label: 'INVENTORY_TYPE',
        filterType: 'SELECT',
        parseFunction: this.gridService.parsePublisherHB,
        parseTooltipFunction: this.gridService.parsePublisherHBTooltip,
        featureFlag: 'publisher_hb',
      },
      { key: 'impressions', label: 'OPPORTUNITIES' },
      { key: 'adStarts', label: 'IMPRESSIONS' },
      { key: 'adStartsPercent', label: 'AD_STARTS_PERCENTAGE' },
      { key: 'revenue', label: 'REVENUE' },
      { key: 'RPM', label: 'RPM' },
      { key: 'cost', label: 'COST' },
    ];
    this.startDate = new Date();
    this.endDate = new Date();
    this.isLoading = false;
    this.isError = false;
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.initialize();
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.initialize();
        }
      })
    );
    this.sharedService.setPageTitle('PUBLISHERS');
  }

  initialize() {
    const startDate: Date = _.cloneDeep(this.startDate);
    const endDate: Date = _.cloneDeep(this.endDate);
    let params: any;
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    this.isLoading = true;
    params = { startDate: startDate.toString(), endDate: endDate.toString() };
    if (this.currSubscription) {
      this.currSubscription.unsubscribe();
    }
    this.currSubscription = this.httpService.post('publishers/getPublishers', params).subscribe(
      (response: any) => {
        const data: Array<any> = _.cloneDeep(response);
        data.forEach((row: any) => {
          row.active = row.publisher_status === '1';
          row.publisher_hb = +row.publisher_hb;
          row.$$actions = [{ type: 'EDIT', link: false }];
          row.$$link = '/publishers/manage/' + row.publisher_id;
        });
        this.data = data;
        this.isLoading = false;
      },
      (error: any) => {
        // Display the error message
        this.isLoading = false;
        this.isError = true;
      }
    );
    this.subscriptions.push(this.currSubscription);
  }

  // Handle a 'start-date-changed' event from the datepicker component
  startDateChanged($event: any) {
    this.startDate = $event;
  }

  // Handle an 'end-date-changed' event from the datepicker component
  endDateChanged($event: any) {
    this.endDate = $event;
    if (this.endDate !== null) {
      this.initialize();
    }
  }

  onEditClick($event: any) {
    this.router.navigate([$event.$$link]);
  }
}
